import { createFileRoute, redirect } from '@tanstack/react-router'

import { logout } from '@/lib/auth'

export const Route = createFileRoute('/logout')({
  async loader() {
    await logout()
    throw redirect({ to: '/auth/login', replace: true })
  },
})
